import { useState, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  Rating,
  Card,
  MuiList,
  Button,
  ListItemButton,
  ListItemIcon,
  Icon,
  DialogActions,
  Stack,
  TextField,
  IconButton,
} from "@pankod/refine-mui";

import { LoadingButton } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import WebsiteVisualizer from "templater/WebsiteVisualizer";

import axios from "utils/axios";
import { toast } from "react-toastify";
import { normalizeData, truncateString } from "utils/utils";
import { useParams } from "react-router-dom";
import { authProvider } from "authProvider";

export default function CompFields({
  register,
  control,
  errors,
  getValues,
  setError,
  setValue,
  watch,
}) {
  const fields = [
    {
      label: "Gallery",
      name: "photos_sample",
      type: "gallery",
      accessor: "photo_url",
      height: 500,
      viewOnly: true,
    },
    {
      label: "Name",
      name: "name",
      type: "text",
      md: 9,
      viewOnly: true,
    },
    {
      label: "Type",
      name: "type",
      type: "text",
      md: 3,
      viewOnly: true,
    },
    {
      label: "About",
      name: "about",
      type: "text",
      lines: 4,
      viewOnly: true,
    },
    {
      label: "Address",
      name: "address",
      type: "text",
      viewOnly: true,
    },
    {
      label: "Phone",
      name: "phone",
      type: "text",
      md: 3,
    },
    {
      label: "Website",
      name: "website",
      type: "text",
      md: 3,
    },
    {
      label: "Emails",
      name: "emails",
      type: "text",
    },
    {
      label: "Reviews",
      name: "review_count",
      type: "number",
      md: 5,
      viewOnly: true,
    },
    {
      label: "Rating",
      name: "rating",
      type: "number",
      md: 5,
      viewOnly: true,
    },
    {
      label: "Notes",
      name: "notes",
      type: "text",
      lines: 4,
    },
  ];

  const params = useParams();

  const [user, setUser] = useState(authProvider.getUserCached());

  const [sending, setSending] = useState(false);
  const [sentiments, setSentiments] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState(null);
  const [messageContent, setMessageContent] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectingTemplate, setSelectingTemplate] = useState(false);
  const [website, setWebsite] = useState(null);
  const [addingToCategory, setAddingToCategory] = useState(false);
  const [categories, setCategories] = useState([]);
  const [associatedCategories, setAssociatedCategories] = useState(null);
  const [contacts, setContacts] = useState([]);

  // fetch message templates
  useEffect(() => {
    (async () => {
      try {
        let { data: templates } = await axios.get(
          "/api/message-templates?populate=*"
        );
        let norm = normalizeData(templates.data);
        setTemplates(norm);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  // fetch existing messages
  const fetchMessages = async () => {
    try {
      let { data: messages } = await axios.get(
        `/api/messages?filters[business]=${params.id}&populate=*`
      );
      let norm = normalizeData(messages.data);
      setMessages(norm);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategories = async () => {
    try {
      let { data: categories } = await axios.get(`/api/categories?populate=*`);
      let norm = normalizeData(categories);
      setCategories(norm);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAssociatedCategories = async () => {
    try {
      let { data: business } = await axios.get(
        `/api/businesses/${params.id}?populate=*`
      );
      let norm = normalizeData(business.data);
      setAssociatedCategories(norm.categories);
      setContactsFromData(norm);
    } catch (error) {
      console.log(error);
    }
  };

  const setContactsFromData = (business) => {
    let entries = Object.entries(business?.emails_and_contacts || {});
    let contacts = (entries || []).map(([key, value]) => {
      if (!Array.isArray(value))
        return {
          contactType: key,
          href: value,
        };
    });
    contacts = (contacts || []).filter((contact) => contact !== undefined);
    setContacts(contacts);
  };

  useEffect(() => {
    fetchMessages();
    fetchCategories();
    fetchAssociatedCategories();
  }, []);

  return (
    <Grid container spacing={2} justifyContent="space-between">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            defaultValue={watch(field.name)}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}

      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4">Messages</Typography>
        </Grid>
        {messages.map((message, index) => (
          <Grid item xs={12} key={index}>
            <Card sx={{ p: 2 }}>
              <Grid container>
                <Grid
                  item
                  xs={1}
                  container
                  justifyContent="center"
                  alignItems="center"
                >
                  <IconButton
                    onClick={() => {
                      setMessage(message);
                      setMessageContent(message.content);
                    }}
                  >
                    <Icon>message</Icon>
                  </IconButton>
                </Grid>
                <Grid item xs={11}>
                  <Typography variant="h6">
                    {message?.message_template?.name}
                  </Typography>
                  <Typography variant="body1">
                    {truncateString(message?.content || "", 150)}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="flex-end">
        <Grid item>
          <Button variant="contained" onClick={() => setAddingToCategory(true)}>
            Add to List
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            onClick={() => {
              window.open(
                `https://www.google.com/search?q=${getValues(
                  "name"
                )} ${getValues("address")}`,
                "_blank"
              );
            }}
          >
            Search on Google
          </Button>
        </Grid>
        <Grid item>
          <LoadingButton
            loading={sending}
            variant="contained"
            onClick={async () => {
              setSending(true);
              try {
                let { data: reviewStats } = await axios.post(
                  "/api/get-sentiment",
                  {
                    id: params.id,
                    lang: "en",
                    limit: 3,
                  }
                );
                let incomingData = {
                  reviews: reviewStats.reviews,
                  rating: reviewStats.rating,
                  review_count: reviewStats.review_count,
                  reviews_per_rating: reviewStats.reviews_per_rating,
                };
                setSentiments(
                  <Grid item xs={12}>
                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent="center"
                      spacing={4}
                    >
                      <Grid item xs={12} container justifyContent="center">
                        <Typography
                          variant="h6"
                          sx={{ mb: 2, width: "100%" }}
                          align="center"
                        >
                          Overall Rating:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Rating
                          precision={0.1}
                          size="large"
                          value={incomingData.rating}
                          readOnly
                        />
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography
                          variant="h6"
                          sx={{ mb: 2, width: "100%" }}
                          align="center"
                        >
                          out of {incomingData.review_count} Reviews
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item container xs={12} justifyContent="center">
                      <Card sx={{ my: 1, p: 2, borderRadius: 8 }}>
                        {Object.values(incomingData.reviews_per_rating).map(
                          (rating, index) => (
                            <Grid
                              item
                              container
                              justifyContent="center"
                              alignItems="center"
                              spacing={4}
                              key={index}
                            >
                              <Grid item>
                                <Rating
                                  size="small"
                                  value={index + 1}
                                  readOnly
                                />
                              </Grid>
                              <Grid item>
                                <Typography variant="body1">
                                  {rating}
                                </Typography>
                              </Grid>
                            </Grid>
                          )
                        )}
                      </Card>
                    </Grid>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                      Sample Reviews
                    </Typography>
                    <Divider sx={{ my: 2, width: "100%" }} />
                    {incomingData.reviews.map((review, index) => (
                      <Grid item xs={12} key={index}>
                        <Rating value={review.rating} />
                        <Typography variant="body1">
                          {review.review_text}
                        </Typography>
                        <Divider sx={{ my: 2, width: "100%" }} />
                      </Grid>
                    ))}
                  </Grid>
                );
                setSending(false);
              } catch (error) {
                console.log(error);
                setSending(false);
              }
            }}
          >
            Check Reviews
          </LoadingButton>
        </Grid>
        <Grid item>
          <LoadingButton
            loading={sending}
            onClick={async () => {
              setSelectingTemplate(true);
            }}
            variant="contained"
          >
            Generate Email
          </LoadingButton>
        </Grid>
        {user?.role?.type == "authenticated" && (
          <Grid item>
            <LoadingButton
              loading={sending}
              onClick={async () => {
                setSending(true);
                try {
                  let { data: website } = await axios.post(
                    "/api/generate-website",
                    {
                      id: params.id,
                      lang: "en",
                    }
                  );
                  setWebsite(website);
                  setSending(false);
                } catch (error) {
                  console.log(error);
                  setSending(false);
                }
              }}
              variant="contained"
            >
              Generate Website
            </LoadingButton>
          </Grid>
        )}
      </Grid>
      {/* sentiment dialog */}
      <Dialog
        open={!!sentiments}
        onClose={() => setSentiments(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Reviews</DialogTitle>
        <DialogContent>
          <Grid item xs={12} container>
            {sentiments}
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Email visualizer dialog */}
      <Dialog
        open={!!message}
        onClose={() => setMessage(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={2}
          >
            <IconButton
              onClick={async () => {
                try {
                  await axios.put("/api/messages/" + message.id, {
                    data: {
                      content: messageContent,
                    },
                  });
                  toast.success("Message saved.");
                  fetchMessages();
                } catch (error) {
                  console.log(error);
                  toast.error("Error while saving message.");
                }
              }}
            >
              <Icon color="success">save</Icon>
            </IconButton>
            <IconButton
              onClick={async () => {
                if (
                  !window.confirm(
                    "Are you sure you want to delete this message?"
                  )
                )
                  return;
                try {
                  await axios.delete("/api/messages/" + message.id);
                  toast.success("Message deleted.");
                  setMessage(null);
                  setMessageContent("");
                  fetchMessages();
                } catch (error) {
                  console.log(error);
                  toast.error("Error while deleting message.");
                }
              }}
            >
              <Icon color="error">delete</Icon>
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <TextField
            label="Message"
            fullWidth
            multiline
            rows={30}
            defaultValue={messageContent}
            onChange={(e) => {
              setMessageContent(e.target.value);
            }}
            sx={{
              width: "100%",
              whiteSpace: "pre-line",
              mb: 2,
            }}
          />
          {/* <Typography
            sx={{ width: "100%", whiteSpace: "pre-line" }}
            display="block"
          >
            {message}
          </Typography> */}
        </DialogContent>
        <DialogActions>
          {(getValues("emails") || "").split(",").map((email, index) => (
            <LoadingButton
              key={index}
              loading={sending}
              variant="contained"
              onClick={async () => {
                setSending(true);
                try {
                  await axios.post("/api/send-message", {
                    mailTo: email,
                    messageID: message.id,
                  });
                  toast.success("Message sent!");
                  setSending(false);
                } catch (error) {
                  console.log(error);
                  toast.error("Error while sending message.");
                  setSending(false);
                }
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Icon>mail</Icon>
                <Typography variant="body1">Send to {email}</Typography>
              </Stack>
            </LoadingButton>
          ))}
        </DialogActions>
      </Dialog>

      {/* Website visualizer dialog */}
      <Dialog open={!!website} onClose={() => setWebsite(null)}>
        {website && <WebsiteVisualizer details={website.website_data} />}
      </Dialog>

      {/* Select message template dialog */}
      <Dialog
        open={selectingTemplate}
        onClose={() => setSelectingTemplate(false)}
      >
        <DialogTitle>Select Template</DialogTitle>
        <DialogContent>
          <MuiList>
            {templates.map((template, index) => (
              <ListItemButton
                key={index}
                onClick={() => {
                  setSelectedTemplate(template);
                }}
              >
                <ListItemIcon>
                  <Icon>mail</Icon>
                </ListItemIcon>
                <Typography variant="body1">{template.name}</Typography>
              </ListItemButton>
            ))}
          </MuiList>
          <DialogActions>
            <LoadingButton
              loading={sending}
              onClick={async () => {
                setSending(true);
                try {
                  let { data: message } = await axios.post(
                    "/api/generate-message",
                    {
                      id: params.id,
                      lang: "en",
                      templateName: selectedTemplate.name,
                    }
                  );
                  setMessage(message);
                  setMessageContent(message.content);
                  setSending(false);
                } catch (error) {
                  console.log(error);
                  setSending(false);
                }
                setSelectingTemplate(false);
                setSelectedTemplate(null);
              }}
              variant="contained"
              disabled={!selectedTemplate}
            >
              {selectedTemplate == null
                ? "No Template Selected"
                : "Generate Email for: " + selectedTemplate.name}
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Adding to Category dialog */}
      {associatedCategories && (
        <Dialog
          open={addingToCategory}
          onClose={() => setAddingToCategory(false)}
        >
          <DialogTitle>Add to Category</DialogTitle>
          <DialogContent>
            <MuiList>
              {categories.map((category, index) => {
                let newList = [...associatedCategories];
                const isInList = newList.find((x) => x.id == category.id);
                if (isInList)
                  newList = newList.filter((x) => x.id !== category.id);
                else newList.push(category);

                return (
                  <ListItemButton
                    key={index}
                    onClick={async () => {
                      setAddingToCategory(false);
                      try {
                        await axios.put("/api/businesses/" + params.id, {
                          data: {
                            categories: newList,
                          },
                        });
                        toast.success(
                          isInList
                            ? "Business removed from list"
                            : "Business added to list"
                        );
                      } catch (error) {
                        console.log(error);
                        toast.error(
                          `Error while ${
                            isInList ? "removing" : "adding"
                          } business ${isInList ? "from" : "to"} list.`
                        );
                      }
                      fetchAssociatedCategories();
                    }}
                  >
                    <ListItemIcon>
                      <Icon>{isInList ? "remove" : "add"}</Icon>
                    </ListItemIcon>
                    <Typography variant="body1">{category.name}</Typography>
                  </ListItemButton>
                );
              })}
            </MuiList>
          </DialogContent>
        </Dialog>
      )}
    </Grid>
  );
}
